<template>
    <div class="global_content_course" :class="{ dark: dark }">
        <div class="course-layout">
            <div class="course-layout__sidebar" :class="showSidebar ? 'is-visible' : 'is-hidden'">
                <SideBar
                    :activeModule="activeModule"
                    :nameCourse="nameCourse"
                    :data="dataModulesxLesson"
                    :currentLesson="currentLesson"
                    @updateLessonName="updateCurrentLessonName"
                    @lessonChanged="updateCurrentLesson"
                    @typeChanged="updateCurrentTypeLesson"
                />
            </div>
            <div class="course-layout__main course-layout__main--with-home-header">
                <Header course-sidebar-menu />
                <ViewCourse :modules-data="dataModulesxLesson" />
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './sidebar.vue';
import ViewCourse from './viewContent.vue';
import Header from '@/components/Student/Dashboard_Unique/Header/Header.vue';

import api from '@/utils/portal/modulesLesson.js';
import apiCourse from '@/utils/portal/course.js';
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';

export default {
    data() {
        return {
            dataModulesxLesson: null,
            currentLessonLocal: null,
            currentLessonName: null,
            typeCurrentLesson: null,
            nameCourse: null,
            activeModule: 11,
            listLesson: [],
            dataCourse: null,
            hasLastLesson: false,
        };
    },
    components: {
        SideBar,
        ViewCourse,
        Header,
    },
    computed: {
        ...mapState([
            'token',
            'showSidebar',
            'dark',
            'currentLesson',
            'currentModuleOpen',
            'idLessonPortal',
            'nameCurrentLesson',
            'currentCoursePortal',
        ]),
    },
    methods: {
        ...mapActions([
            'storeTypeLessonPortal',
            'storeIdLessonPortal',
            'storeCurrentModuleOpen',
            'storeCurrentLesson',
            'storeNameCurrentLesson',
            'storePorcetageProgressCurrentCourse',
        ]),

        async getCourseProgressFromAPI() {
            try {
                if (
                    this.currentCoursePortal &&
                    this.currentCoursePortal.course &&
                    this.currentCoursePortal.course.id
                ) {
                    const courseResponse = await apiCourse.getDataCourse(
                        this.token,
                        this.currentCoursePortal.course.id
                    );
                    if (courseResponse && courseResponse.progress != null) {
                        this.storePorcetageProgressCurrentCourse({
                            porcetageProgressCurrentCourse: courseResponse.progress,
                        });
                        return courseResponse.progress;
                    }
                }
            } catch (error) {
                console.error('Erro ao carregar progresso do curso:', error);
            }
            return null;
        },

        getLessonsArray(data) {
            const lessonsArray = [];
            data.forEach((item) => {
                if (item.lessons) {
                    lessonsArray.push(...item.lessons);
                }
            });
            this.listLesson = lessonsArray;

            if (this.listLesson && this.listLesson.length > 0) {
                this.storeIdLessonPortal({ idLessonPortal: this.listLesson[0].id });
                this.storeCurrentLesson({ currentLesson: this.listLesson[0] });
                this.storeTypeLessonPortal({ typeLessonPortal: this.listLesson[0].type });
                this.storeCurrentModuleOpen({ currentModuleOpen: 0 });
                this.storeNameCurrentLesson({ nameCurrentLesson: this.listLesson[0].title });
            } else {
                console.warn('Nenhuma lição encontrada ao processar os módulos.');
            }
        },

        async getDataLessonAndModules(id) {
            try {
                const response = await api.getDataModulesAndLesson(this.token, id);
                this.dataModulesxLesson = response;
                this.getLessonsArray(response);
                await this.getCourseProgressFromAPI();
            } catch (error) {
                toast.error('Erro ao gerar a lista de módulos e lições');
                console.error('Erro ao gerar a lista de módulos e lições');
            }
        },

        updateCurrentLesson(lessonId, typeLesson) {
            this.storeCurrentLesson({ currentLesson: lessonId });
            this.typeCurrentLesson = typeLesson;
        },
        updateCurrentTypeLesson(typeLesson) {
            this.typeCurrentLesson = typeLesson;
        },
        updateCurrentLessonName(nameLesson) {
            this.currentLessonName = nameLesson;
        },
        updateReviewMode(review) {
            this.currentLessonName = review;
        },
    },
    async created() {
        const idCourse = this.$route.params.slug;
        await this.getDataLessonAndModules(idCourse);

        if (typeof this.getLastLesson === 'function') {
            await this.getLastLesson(idCourse);
        }
    },
};
</script>

<style scoped>
.global_content_course {
    background-color: #f8fafc;
    --course-shell-bg: #f8fafc;
    box-sizing: border-box;
    width: 100%;
    height: 100vh;
    min-height: 100vh;
}

.global_content_course.dark {
    background-color: #0f0e12;
    --course-shell-bg: #0f0e12;
}

.course-layout {
    display: flex;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    max-width: 1600px;
    margin: 0 auto;
    width: 100%;
}

.course-layout__sidebar {
    flex-shrink: 0;
    width: 300px;
    min-width: 280px;
    max-width: 100%;
}

@media (max-width: 768px) {
    .course-layout__sidebar {
        width: 85%;
        max-width: 320px;
    }
}

.course-layout__sidebar.is-hidden {
    display: none;
}

.course-layout__main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    background: var(--course-shell-bg);
}

.course-layout__main--with-home-header :deep(.global_header.weeducStudentHeader) {
    flex-shrink: 0;
}

.course-layout__main--with-home-header > :deep(.global_view_content) {
    flex: 1;
    min-height: 0;
}
</style>

<style>
.global_content_course.dark .box_question_quiz.review {
    background-color: #2a2a2a;
    color: white;
}
.global_content_course.dark .number_question_quiz {
    border-bottom: 1px solid #1a1a1a;
}
</style>
